const normalizeArtistPriority = (value) => {
  if (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return null;
  }

  const priority = Number(value);
  return Number.isFinite(priority) ? priority : null;
};

export const getArtistPriority = (item = {}) =>
  normalizeArtistPriority(
    item.priority ??
      item.artist?.priority ??
      item.artist?.meta?.bin?.priority
  );

/**
 * Return a stable artist order with the highest numeric priority first.
 * Missing/invalid priorities remain at the end in their API order.
 */
export const orderArtistItemsByPriority = (items = []) => {
  if (!Array.isArray(items)) return [];

  return items
    .map((item, index) => ({
      item,
      index,
      priority: getArtistPriority(item),
    }))
    .sort((a, b) => {
      if (a.priority === null && b.priority === null) {
        return a.index - b.index;
      }
      if (a.priority === null) return 1;
      if (b.priority === null) return -1;
      return b.priority - a.priority || a.index - b.index;
    })
    .map(({ item }) => item);
};
